var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Avatar as KendoAvatar } from '@progress/kendo-react-layout';
var StyledAvatar = styled(KendoAvatar)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

/**
 * The Avatar component is typically used to display images,
 * icons, or initials representing people or other entities.
 */
var Avatar = props => /*#__PURE__*/React.createElement(StyledAvatar, props);
Avatar.defaultProps = {
  border: false,
  children: undefined,
  className: undefined,
  fillMode: 'solid',
  rounded: 'medium',
  size: 'medium',
  style: undefined,
  themeColor: 'primary',
  type: 'text'
};
Avatar.propTypes = {
  /**
   * Sets a border to the Avatar.
   */
  border: PropTypes.bool,
  /**
   * Sets the Avatar children elements.
   */
  children: PropTypes.node,
  /**
   * Add additional classes to the Avatar.
   */
  className: PropTypes.string,
  /**
   * Configures the fillMode of the Button.
   * The available options are: 'solid' | 'outline' | null (Does not set a fillMode className)
   */
  fillMode: PropTypes.oneOf([null, 'outline', 'solid']),
  /**
   * Configures the roundness of the Button.
   * The available options are: 'small' | 'medium' | 'large' | 'full' |
   * null (Does not set a rounded className)
   */
  rounded: PropTypes.oneOf([null, 'small', 'medium', 'large', 'full']),
  /**
   * Configures the size of the Button.
   * The available options are: 'small' | 'medium' | 'large' |
   * null (Does not set a size className)
   */
  size: PropTypes.oneOf([null, 'small', 'medium', 'large']),
  /**
   * Sets additional CSS styles to the Avatar.
   */
  style: PropTypes.shape({}),
  /**
   * Configures the themeColor of the Button.
   * The available options are: 'base' | 'primary' | 'secondary' | 'tertiary' | 'info' |
   * 'success' | 'error' | 'warning' | 'dark' | 'light' | 'inverse' |
   * null (Does not set a themeColor className)
   */
  themeColor: PropTypes.oneOf([null, 'error', 'inverse', 'base', 'success', 'dark', 'light', 'primary', 'secondary', 'tertiary', 'info', 'warning']),
  /**
   * Set the type of the Avatar.
   * The supported values are: 'image' | 'text' | 'icon'
   */
  type: PropTypes.oneOf(['image', 'text', 'icon'])
};
export default Avatar;